import React, { Component } from 'react';
import ColorPicker from './ColorPicker';

import flatten from 'lodash/flatten';
import size from 'lodash/size';


class GradientPicker extends Component {
  
  render () {
    const { colors, onChange } = this.props;
    let value = flatten([this.props.value]);
    
    if (size(value) === 1){
      value = [value[0], value[0]];
      onChange(value);
    }
    
    return (<div className="gradient-picker">
      <ColorPicker value={value[0]} colors={colors} onChange={(color) => onChange([color, value[1]]) } discrette />
      <ColorPicker value={value[1]} colors={colors} onChange={(color) => onChange([value[0], color]) } discrette />
    </div>)
  }
};

export default GradientPicker;


// WEBPACK FOOTER //
// ./src/components/helpers/GradientPicker.js